import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./StudentStories.scss";
import StudentStoriesIcon from "../Assets/images/background/student-stories-icon.svg";
import { getStory } from "../services/getStory";
import { Link } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import Men from "../Assets/images/MEN.png"
import Women from "../Assets/images/WOMEN.png"


const StudentStories = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 767, min: 320 },
      items: 1,
    },
  };

  const [storyData, setStoryData] = useState([]);
  const fetchData = async () => {
    await getStory()
      .then((data) => {
        setStoryData(data.data.slice(0, 5));
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!storyData.length) {
    return null;
  }

  return (
    <div className="container">
    <div className="student-stories-container">
      <h2 className="title">Student Reviews</h2>
      <span className="description">
        DoubtQ  has got 3k+ positive student ratings from different countries of
        the world. <br></br>Their positive reviews show how DoubtQ dedicatedly helped
        them to grow
      </span>
      <div className="carousel-container">
        <Carousel
          responsive={responsive}
          autoPlay={true}
          arrows={false}
          swipeable={true}
          draggable={true}
          showDots={true}
          infinite={true}
        // partialVisible={false}
        >
          {storyData.map((e, index) => {
            return (
              <div key={index} className="carousel story">
                <Link className="text-decoration-none" to="/reviews">
                  <div className="carousel-header">
                    {/* <img src={ImageLink(e.image)} className="carousel-img" alt="carousel" /> */}
                    <img
                      className="carousel-img"
                      src={e.status === "Male" ? Men : Women}
                      alt={e.status === "Male" ? "Man" : "Woman"}
                    />
                    <div>
                      <div className="carousel-title">{e.name}</div>
                      <div className="carousel-subtitle">{e.title}</div>
                    </div>
                    <div className="carousel-icon">
                      <img
                        src={StudentStoriesIcon}
                        className="carousel-img"
                        alt="carousel-icon"
                      />
                    </div>
                  </div>
                  <div className="carousel-description mt-2">{e.description}</div>
                  <div className='rating-review'>
                    <Rating 
                      initialValue={parseFloat(e.rating)}
                      readonly
                    />
                  </div>
                </Link>
              </div>
            );
          })}
        </Carousel>
        <div className="mt-4">
          <Link to="/reviews">
            <button className="rbt-btn btn-gradient btn-sm">See More Reviews</button>
          </Link>
        </div>
      </div>
    </div>
    </div>
  );
};

export default StudentStories;
